<template>
  <div class="feedback-page">

    <!-- Page header -->
    <div class="page-header">
      <button class="back-btn" onclick="window.history.back()"><i class="ft-arrow-left"></i></button>
      <div class="header-info">
        <span class="page-title">Feedback</span>
        <span class="page-subtitle">Share your experience</span>
      </div>
    </div>

    <!-- Ward / Bed selectors -->
    <div class="section-pad">
      <div class="selection-card">

        <div class="select-group" v-if="wards.length > 0">
          <label class="select-label"><i class="ft-map-pin"></i> Ward</label>
          <div class="select-wrap">
            <select id="ward-select" v-on:change="wardChanged($event)" v-model="ward">
              <option value="">Select Ward</option>
              <option v-for="w in wards" v-bind:key="w.ward_id" :value="w.ward_id">{{ w.ward_name }}</option>
            </select>
            <i class="ft-chevron-down select-arrow"></i>
          </div>
        </div>

        <div class="select-group" v-if="beds.length > 0">
          <label class="select-label"><i class="ft-user"></i> Patient</label>
          <div class="select-wrap">
            <select id="bed-select" v-on:change="bedChanged($event)">
              <option value="">Select Patient</option>
              <option v-for="bed in beds" v-bind:key="bed.bed_id" :value="bed.bed_id">{{ bed.patient_name }}</option>
            </select>
            <i class="ft-chevron-down select-arrow"></i>
          </div>
        </div>

      </div>
    </div>

    <!-- Questions -->
    <div class="section-pad questions-section" v-if="feedback_questions.length > 0">
      <p class="section-label"><i class="ft-clipboard"></i> Questions</p>

      <div class="question-card" v-for="quest in feedback_questions" :key="quest.id">
        <div class="question-label">{{ quest.name }}</div>

        <!-- Stars 1–5 -->
        <div class="star-wrap" v-if="quest.input_type == 'Stars - 1-5'">
          <div class="star-row">
            <i class="ft-star star-icon star-pos-1" :id="'str-1'+quest.id" v-on:click="setStarRate(1, quest)"></i>
            <i class="ft-star star-icon star-pos-2" :id="'str-2'+quest.id" v-on:click="setStarRate(2, quest)"></i>
            <i class="ft-star star-icon star-pos-3" :id="'str-3'+quest.id" v-on:click="setStarRate(3, quest)"></i>
            <i class="ft-star star-icon star-pos-4" :id="'str-4'+quest.id" v-on:click="setStarRate(4, quest)"></i>
            <i class="ft-star star-icon star-pos-5" :id="'str-5'+quest.id" v-on:click="setStarRate(5, quest)"></i>
          </div>
          <div class="star-labels">
            <span>Poor</span>
            <span>Fair</span>
            <span>Good</span>
            <span>Very Good</span>
            <span>Excellent</span>
          </div>
        </div>

        <!-- Emojis 1–5 -->
        <div class="emoji-wrap" v-if="quest.input_type == 'Emojis - 1-5'">
          <div class="emoji-row">
            <button class="emoji-btn" :id="'emj-1'+quest.id" v-on:click="setEmojiRate(1, quest)">😞</button>
            <button class="emoji-btn" :id="'emj-2'+quest.id" v-on:click="setEmojiRate(2, quest)">😕</button>
            <button class="emoji-btn" :id="'emj-3'+quest.id" v-on:click="setEmojiRate(3, quest)">😐</button>
            <button class="emoji-btn" :id="'emj-4'+quest.id" v-on:click="setEmojiRate(4, quest)">😊</button>
            <button class="emoji-btn" :id="'emj-5'+quest.id" v-on:click="setEmojiRate(5, quest)">😄</button>
          </div>
          <div class="emoji-labels">
            <span>Poor</span>
            <span>Fair</span>
            <span>Good</span>
            <span>Very Good</span>
            <span>Excellent</span>
          </div>
        </div>

        <!-- Dropdown -->
        <div class="select-wrap" v-if="quest.input_type == 'Dropdown'">
          <select v-on:change="setAnswer($event, quest)">
            <option value="">Choose an option…</option>
            <option v-for="rate in getArray(quest.choices)" :value="rate">{{ rate }}</option>
          </select>
          <i class="ft-chevron-down select-arrow"></i>
        </div>

        <!-- Checkbox -->
        <div class="checkbox-group" v-if="quest.input_type == 'CheckBox'">
          <label
            class="checkbox-item"
            v-for="rate in getArray(quest.choices)"
            :key="rate"
          >
            <input type="checkbox" :class="'check-' + quest.id" :value="rate" @change="setCheckboxRate(quest)">
            <span class="checkbox-box"></span>
            <span class="checkbox-label">{{ rate }}</span>
          </label>
          <p class="no-choices-hint" v-if="!quest.choices">No options configured for this question.</p>
        </div>

        <!-- Text input -->
        <input
          v-if="quest.input_type == 'Textbox' || quest.input_type == ''"
          type="text"
          class="q-input"
          placeholder="Your answer…"
          :id="'quest-' + quest.id"
          v-on:keyup="setCommentRate(quest)"
        >

        <!-- Textarea -->
        <textarea
          v-if="quest.input_type == 'textarea' || quest.input_type == 'TextArea'"
          class="q-textarea"
          placeholder="Your answer…"
          :id="'quest-' + quest.id"
          v-on:keyup="setCommentRate(quest)"
        ></textarea>

      </div>
    </div>

    <!-- Submit -->
    <div class="submit-pad" v-if="feedback_questions.length > 0">
      <button class="submit-btn" v-on:click="send_feedback()">
        <i class="ft-send"></i> Submit Feedback
      </button>
    </div>

  </div>
</template>

<script>
import moment from 'moment'
import swal from 'sweetalert'

export default {
  name: 'feedback',
  data: function () {
    return {
      merchant: {},
      floors: [],
      date: moment().format('DD MMMM YYYY'),
      time: moment().format('h:mm'),
      wards: [],
      hospitals: [],
      beds: [],
      bed: { bed_id: '' },
      ward: '',
      bed_id: '',
      ward_id: '',
      periods: [],
      period: '',
      survey_id: '',
      token: window.localStorage.getItem('token'),
      rate: [],
      feedback_questions: [],
      category: [],
      cart: window.localStorage.getItem('cart') ? JSON.parse(window.localStorage.getItem('cart')) : []
    }
  },
  mounted: function () {
    this.$store.commit('SET_LAYOUT', 'AppLayout')
    var user = JSON.parse(window.localStorage.getItem('user'))
    var that = this
    that.rate = []
    that.wards = user.merchant.wards
    that.feedback_questions = JSON.parse(window.localStorage.getItem('review_questions'))
    that.basic_login()
    if (that.feedback_questions.length === 0) {
      swal('Error', 'Couldn\'t find feedback questions.', 'error').then(function () {
        that.$router.push('/')
      })
    }
  },
  methods: {
    basic_login: function () {
      var that = this
      var data = {
          username: window.localStorage.getItem('username'),
        password: window.localStorage.getItem('password'),
        deviceId: window.localStorage.getItem('deviceId'),
        imei: window.localStorage.getItem('imei'),
        uuid: window.localStorage.getItem('uuid'),
        device_name: window.localStorage.getItem('device_name'),
        os_version: window.localStorage.getItem('version'),
        os:cordova.platformId
      }
      $.showLoading()
      $.ajax({
        beforeSend: function (xhr) {
          $.hideLoading()
        },
        url: this.$config.apiUrl + 'basic/login',
        type: 'post',
        data: JSON.stringify(data),
        success: function (data) {
          if (typeof data.success !== 'undefined' && data.success === true) {
            window.localStorage.setItem('user', JSON.stringify(data.data))
            window.localStorage.setItem('token', data.meta.token)
            window.localStorage.setItem('review_questions', JSON.stringify(data.data.review_questions))
            that.feedback_questions = JSON.parse(window.localStorage.getItem('review_questions'))
          }
        },
        error: function (data) {
          var meta = JSON.parse(data.responseText)
          swal('Error', meta.meta.reason, 'error')
        }
      })
    },
    bedChanged: function (event) {
      this.bed_id = event.target.value
    },
    setJson: function (data) {
      return JSON.stringify(data)
    },
    wardChanged: function (event) {
      var that = this
      var ward_id = event.target.value
      that.ward_id = ward_id
      if (ward_id !== '') {
        $.ajax({
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', window.localStorage.getItem('token'))
          },
          url: this.$config.apiUrl + 'medicater/beds/' + ward_id,
          type: 'get',
          success: function (data) {
            that.beds = data.data
          },
          error: function (data) {
            if (window.localStorage.getItem(this.url)) {
              var offlineData = JSON.parse(window.localStorage.getItem(this.url))
              this.success(offlineData)
            } else {
              swal({ text: data.responseJSON.message, icon: 'info', button: 'Ok' })
            }
          }
        })
      }
    },
    getArray: function (questions) {
      if (questions != null && questions !== undefined) {
        return questions.split(',')
      }
      return []
    },
    setCheckboxRate: function (quest) {
      var that = this
      for (var i = 0; i < that.rate.length; i++) {
        if (that.rate[i].id == quest.id) that.rate.splice(i, 1)
      }
      var answers = []
      var comma = ''
      $('.check-' + quest.id + ':checked').each(function () {
        answers += $(this).val() + ','
      })
      that.rate.push({ id: quest.id, question: quest.name, answer: answers })
    },
    setEmojiRate: function (num, quest) {
      $('.emoji-btn').removeClass('emoji-selected')
      $('.emoji-wrap').removeClass('emoji-sel-1 emoji-sel-2 emoji-sel-3 emoji-sel-4 emoji-sel-5')
      $('#emj-' + num + quest.id).addClass('emoji-selected')
      $('#emj-' + num + quest.id).closest('.emoji-wrap').addClass('emoji-sel-' + num)
      var that = this
      that.survey_id = quest.survey_id
      for (var i = 0; i < that.rate.length; i++) {
        if (that.rate[i].id == quest.id) that.rate.splice(i, 1)
      }
      that.rate.push({ id: quest.id, question: quest.name, answer: num })
    },
    setStarRate: function (num, quest) {
      var new_num = num + 1
      $('.ft-star').removeClass('rated')
      $('.star-wrap').removeClass('selected-1 selected-2 selected-3 selected-4 selected-5')
      for (var r = 0; r < new_num; r++) {
        $('#str-' + r + quest.id).addClass('rated')
      }
      $('#str-' + num + quest.id).closest('.star-wrap').addClass('selected-' + num)
      var that = this
      that.survey_id = quest.survey_id
      for (var i = 0; i < that.rate.length; i++) {
        if (that.rate[i].id == quest.id) that.rate.splice(i, 1)
      }
      that.rate.push({ id: quest.id, question: quest.name, answer: num })
    },
    setCommentRate: function (quest) {
      var that = this
      that.survey_id = quest.survey_id
      for (var i = 0; i < that.rate.length; i++) {
        if (that.rate[i].id == quest.id) that.rate.splice(i, 1)
      }
      that.rate.push({ id: quest.id, question: quest.name, answer: $('#quest-' + quest.id).val() })
    },
    setAnswer: function (event, quest) {
      var that = this
      that.survey_id = quest.survey_id
      for (var i = 0; i < that.rate.length; i++) {
        if (that.rate[i].id == quest.id) that.rate.splice(i, 1)
      }
      that.rate.push({ question: quest.name, answer: event.target.value, id: quest.id })
    },
    send_feedback: function () {
      var that = this
      var user = JSON.parse(window.localStorage.getItem('user'))
      if (that.ward_id === '') { swal('Error', 'Please select a ward.', 'error'); return false }
      if (that.bed_id === '') { swal('Error', 'Please select a patient.', 'error'); return false }
      if (that.rate.length === 0) { swal('Error', 'Please answer at least one question.', 'error'); return false }
      var postData = {
        bed_id: that.bed_id,
        ward_id: that.ward_id,
        merchant_id: user.merchant.id,
        answers: that.rate,
        survey_id: that.survey_id,
        token: window.localStorage.getItem('token')
      }
      $.showLoading()
      $.ajax({
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', window.localStorage.getItem('token'))
        },
        complete: function () { $.hideLoading() },
        url: this.$config.apiUrl + 'content/save_review',
        type: 'post',
        data: JSON.stringify(postData),
        success: function (response) {
          $.hideLoading()
          that.rate = []
          swal('Success', response.message, 'success').then(function () {
            that.$router.push('/')
          })
        },
        error: function (data) {
          $.hideLoading()
          swal('Error', data.responseJSON ? data.responseJSON.message : 'Something went wrong, please try again.', 'error')
        }
      })
    }
  }
}
</script>

<style scoped>
.feedback-page {
  min-height: 100vh;
  background: #f0f4f8;
  padding-bottom: 100px;
}

/* ── Page header ── */
.page-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 30px 20px 20px;
  background: linear-gradient(135deg, #1a587b 0%, #0f3d5c 100%);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 10;
  margin-top: 3.2rem;
  border-radius: 0;
  box-shadow: 0 8px 32px rgba(15, 61, 92, 0.35);
}

.back-btn {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.15s;
}
.back-btn:hover { background: rgba(255, 255, 255, 0.25); }

.header-info { display: flex; flex-direction: column; gap: 3px; min-width: 0; }

.page-title {
  font-size: 1.05rem;
  font-weight: 700;
  color: #fff;
  letter-spacing: 0.2px;
}

.page-subtitle {
  font-size: 0.73rem;
  color: rgba(255, 255, 255, 0.65);
  font-weight: 500;
}

/* ── Section ── */
.section-pad {
  padding: 110px 16px 0;
}
.section-pad + .section-pad {
  padding-top: 16px;
}

.section-label {
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  color: #64748b;
  margin: 0 0 12px;
  display: flex;
  align-items: center;
  gap: 6px;
}

/* ── Selection card ── */
.selection-card {
  background: #fff;
  border-radius: 14px;
  padding: 18px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.07);
  border: 1px solid #e8edf2;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.select-group { display: flex; flex-direction: column; gap: 8px; }

.select-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: #475569;
  display: flex;
  align-items: center;
  gap: 6px;
}

.select-wrap { position: relative; }

.select-wrap select {
  width: 100%;
  appearance: none;
  -webkit-appearance: none;
  background: #f8fafc;
  border: 1.5px solid #e2e8f0;
  border-radius: 10px;
  padding: 11px 38px 11px 14px;
  font-size: 0.875rem;
  color: #0f172a;
  cursor: pointer;
  outline: none;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.select-wrap select:focus {
  border-color: #1a587b;
  box-shadow: 0 0 0 3px rgba(26, 88, 123, 0.12);
}

.select-arrow {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 0.8rem;
  color: #94a3b8;
  pointer-events: none;
}

/* ── Questions ── */
.questions-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.question-card {
  background: #fff;
  border-radius: 14px;
  padding: 18px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.07);
  border: 1px solid #e8edf2;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.question-label {
  font-size: 0.9rem;
  font-weight: 600;
  color: #0f172a;
  line-height: 1.4;
}

/* Stars */
.star-wrap { display: flex; flex-direction: column; gap: 6px; }
.star-row {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
}
.star-labels {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
}
.star-labels span {
  font-size: 0.62rem;
  color: #94a3b8;
  font-weight: 600;
  text-align: center;
}

.star-icon {
  font-size: 2rem;
  color: #cbd5e1;
  cursor: pointer;
  transition: color 0.15s, transform 0.1s;
  text-align: center;
}
.star-icon:hover { transform: scale(1.15); }

.star-wrap.selected-1 .star-icon.rated { color: #ef4444; }
.star-wrap.selected-2 .star-icon.rated { color: #f97316; }
.star-wrap.selected-3 .star-icon.rated { color: #eab308; }
.star-wrap.selected-4 .star-icon.rated { color: #84cc16; }
.star-wrap.selected-5 .star-icon.rated { color: #10b981; }

.star-wrap.selected-1 .star-labels span:nth-child(-n+1) { color: #ef4444; }
.star-wrap.selected-2 .star-labels span:nth-child(-n+2) { color: #f97316; }
.star-wrap.selected-3 .star-labels span:nth-child(-n+3) { color: #eab308; }
.star-wrap.selected-4 .star-labels span:nth-child(-n+4) { color: #84cc16; }
.star-wrap.selected-5 .star-labels span:nth-child(-n+5) { color: #10b981; }

/* Text input */
.q-input {
  width: 100%;
  padding: 11px 14px;
  border: 1.5px solid #e2e8f0;
  border-radius: 10px;
  font-size: 0.875rem;
  color: #0f172a;
  background: #f8fafc;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.q-input:focus {
  border-color: #1a587b;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(26, 88, 123, 0.12);
}

/* Textarea */
.q-textarea {
  width: 100%;
  min-height: 100px;
  padding: 11px 14px;
  border: 1.5px solid #e2e8f0;
  border-radius: 10px;
  font-size: 0.875rem;
  color: #0f172a;
  background: #f8fafc;
  outline: none;
  resize: vertical;
  box-sizing: border-box;
  font-family: inherit;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.q-textarea:focus {
  border-color: #1a587b;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(26, 88, 123, 0.12);
}

/* Checkbox group */
.checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.checkbox-item {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  padding: 10px 14px;
  border-radius: 10px;
  border: 1.5px solid #e2e8f0;
  background: #f8fafc;
  transition: border-color 0.15s, background 0.15s;
}
.checkbox-item:hover { border-color: #1a587b; background: #f0f9ff; }

.checkbox-item input[type="checkbox"] { display: none; }

.checkbox-box {
  width: 18px;
  height: 18px;
  border-radius: 5px;
  border: 2px solid #cbd5e1;
  flex-shrink: 0;
  background: #fff;
  transition: border-color 0.15s, background 0.15s;
  display: flex;
  align-items: center;
  justify-content: center;
}
.checkbox-item input[type="checkbox"]:checked ~ .checkbox-box {
  border-color: #1a587b;
  background: #1a587b;
}

.checkbox-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #0f172a;
}

.no-choices-hint {
  font-size: 0.8rem;
  color: #94a3b8;
  margin: 0;
  padding: 8px 4px;
}

/* ── Emojis ── */
.emoji-wrap { display: flex; flex-direction: column; gap: 6px; }
.emoji-row {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
}
.emoji-labels {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
}
.emoji-labels span {
  font-size: 0.62rem;
  font-weight: 600;
  color: #94a3b8;
  text-align: center;
}
.emoji-btn {
  background: none;
  border: none;
  font-size: 2rem;
  cursor: pointer;
  text-align: center;
  padding: 4px 0;
  border-radius: 10px;
  opacity: 0.4;
  transition: opacity 0.15s, transform 0.1s;
  line-height: 1;
}
.emoji-btn:hover { opacity: 0.75; transform: scale(1.15); }
.emoji-btn.emoji-selected { opacity: 1; transform: scale(1.2); }

.emoji-sel-1 .emoji-labels span:nth-child(1) { color: #ef4444; }
.emoji-sel-2 .emoji-labels span:nth-child(-n+2) { color: #f97316; }
.emoji-sel-3 .emoji-labels span:nth-child(-n+3) { color: #eab308; }
.emoji-sel-4 .emoji-labels span:nth-child(-n+4) { color: #84cc16; }
.emoji-sel-5 .emoji-labels span:nth-child(-n+5) { color: #10b981; }

/* ── Submit ── */
.submit-pad {
  padding: 20px 16px 0;
}

.submit-btn {
  width: 100%;
  padding: 15px;
  background: linear-gradient(135deg, #1a587b 0%, #0f3d5c 100%);
  color: #fff;
  border: none;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  box-shadow: 0 6px 20px rgba(26, 88, 123, 0.35);
  transition: opacity 0.2s, transform 0.1s;
  letter-spacing: 0.3px;
}
.submit-btn:hover { opacity: 0.92; }
.submit-btn:active { transform: scale(0.98); }
</style>
